/* eslint-disable */

export const editStrategyBotConstants = {
    EDIT_STRATEGY_BOT_REQUEST: 'EDIT_STRATEGY_BOT_REQUEST',
    EDIT_STRATEGY_BOT_SUCCESS: 'EDIT_STRATEGY_BOT_SUCCESS',
    EDIT_STRATEGY_BOT_FAILURE: 'EDIT_STRATEGY_BOT_FAILURE',
};
